// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import * as Profile from 'app/entities/Profile';
import MaybeLoad from 'app/common/components/MaybeLoad';
import TopBar from 'app/viewport/components/TopBar/TopBar';
import TopBarConfigs from 'app/viewport/components/TopBar/TopBarConfigs';
import hocify from 'app/common/components/hocify';
import maybeRender from 'app/common/components/maybeRender';
import { currentUrl } from 'app/common/utils/RouterSelectors';
import { isUrlBlacklisted } from 'app/common/utils/UrlUtils';

import { type Dispatch } from 'app/common/types';

// Should probably move this to routes, but there may be server-only routes here.
const hiddenRouteMatches = [
  '/engine/auth',
  '/sign-up',
  '/app/login',
  '/app/editor',
  '/app/onboarding',
  '/app/instant',
  '/app/settings-v2',
];

const mapStateToProps = state => {
  const shouldRender = !isUrlBlacklisted(currentUrl(state), hiddenRouteMatches);

  if (!shouldRender) {
    return {};
  }

  const configArgs = {
    // "Sugar" for frequently accessed entities in `TopBarConfigs`
    currentAccount: Account.selectors.all.currentAccount(state),
    currentProfile: Profile.selectors.all.currentProfile(state),
    state,
  };

  const config =
    _.find(TopBarConfigs, topBarConfig =>
      topBarConfig.shouldRender(configArgs)
    ) || {};

  return {
    kind: config.kind,
    // Note that this is called `ChildComponent` to avoid collisions
    // with `Component` in `MaybeLoad` / `hocify`.
    ChildComponent: config.ChildComponent,
    // $FlowFixMe
    componentProps: config.mapStateToProps
      ? config.mapStateToProps(configArgs)
      : {},

    // HOC-only props
    shouldRender: !!config.ChildComponent,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onLoad() {
      dispatch(Account.actions.loadCollection());
      dispatch(Profile.actions.loadCollection());
    },
  };
};

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  hocify(MaybeLoad),
  maybeRender(props => props.shouldRender)
)(TopBar);
